import type { Document } from '@contentful/rich-text-types';
import type { BoxProps } from 'rebass';
import { tv } from 'tailwind-variants';

import { withErrorBoundary } from '../ErrorBoundary';
import { documentToReactComponents } from '../RichText';

import {
  StyledAuthor,
  StyledAuthorContentWrapper,
  StyledAuthorWrapper,
  StyledBox,
  StyledImage,
  StyledInfo,
  StyledQuote,
  StyledSeparator,
} from './Styled';

const styling = tv({
  slots: {
    container: 'blockquote-container',
    image: 'blockquote-image',
    imageContainer: 'blockquote-image-container',
    quote: 'blockquote-quote',
  },
});

export interface BlockquoteProps extends BoxProps {
  /** quote text */
  quote: string | Document;
  /** optional author */
  author?: string | null;
  /** author info */
  authorInfo?: string;
  imageUrl?: string;
}

const Blockquote = ({ quote, author, authorInfo, imageUrl, color, ...props }: BlockquoteProps) => {
  const styles = styling();

  return (
    <StyledBox {...props} className={styles.container()} data-color={color}>
      {typeof quote === 'string' ? (
        <StyledQuote className={styles.quote()}>{quote}</StyledQuote>
      ) : (
        <StyledQuote className={styles.quote()}>{documentToReactComponents(quote)}</StyledQuote>
      )}
      {author && (
        <StyledAuthorWrapper className={styles.imageContainer()}>
          {imageUrl && (
            <StyledImage
              sx={{
                backgroundImage: `url(${imageUrl}?f=face)`,
              }}
              className={styles.image()}
            />
          )}
          <StyledAuthorContentWrapper>
            <StyledSeparator />
            <StyledAuthor>{author}</StyledAuthor>
            {authorInfo && <StyledInfo>{authorInfo}</StyledInfo>}
          </StyledAuthorContentWrapper>
        </StyledAuthorWrapper>
      )}
    </StyledBox>
  );
};

export default withErrorBoundary<BlockquoteProps>(Blockquote, { componentName: 'Blockquote' });
